export const LOGIN = "/";
export const DASHBOARD = "/dashboard";
export const TWITTER_FEED = "/twitterfeed";
export const AI_DECISION_MAKER = "/aidecisionmakers";
export const AI_LEADS = "/aileads";
export const AI_PATH = "/aipath";
export const AI_PROFILE = "/aiprofile/:tab";
export const AI_PROFILE_FORM_TABLE = "/aiprofileformtable";
export const AI_PROSPECT_PROFILE = "/aiprospectprofile";
export const COMPANY_PROFILE_SCREEN = "/companyprofilescreen/:id/:tab";
export const CONTACT_US = "/contactus";
export const FAQ_SCREEN = "/faqscreen";
export const JOI_TRAINING = "/joitraining";
export const ATLAS_TRAINING = "/atlastraining";
export const ATLAS_PROMPT_LIBRARY = "/atlaspromptlibrary";
export const COMING_SOON = "/comingSoon";
export const LOGIN_CALLBACK = "/login/callback";
export const PDF_SAMPLE = "/pdfSample";
export const DATA_ENRICH = "/dataenrich";
export const TRACKING = "/tracking";
export const BRE = "/bre";
export const LEGISLATIVE_MAP = "/legislativemap";
export const ARCHIVED = "/archived";
export const SCHEDULED_REPORTS = "/scheduled-reports";
export const FAVORITES = "/favorites";
export const FAVORITES_LIST = "/favoritesList";
export const PROFILE = "/Profile/:id";
export const ERROR_SCREEN = "/ErrorScreen";
export const MAINTENANCE = "/maintainance";
export const PROSPECT_SEARCH_RESULTS = "/people-results";
export const ORGANIZATION_SEARCH_RESULTS = "/organization-results";
export const ATLAS_CHAT = "/atlas-chat";
//videoLinks
export const COMPETITIVE_INTEL_VIDEO =
  "https://player.vimeo.com/video/1029364639?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const PERSONALIZED_DASHBOARD_VIDEO =
  "https://player.vimeo.com/video/1029387379?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const ARCHIVE_VIDEO =
  "https://player.vimeo.com/video/1027029378?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const AI_PROFILE_VIDEO =
  "https://player.vimeo.com/video/1029332944?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const FAVORITES_VIDEO =
  "https://player.vimeo.com/video/1027017531?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const PUSH_TO_JOSF_VIDEO =
  "https://player.vimeo.com/video/1029398107?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const AI_PATH_VIDEO =
  "https://player.vimeo.com/video/1029369634?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const DATA_ENRICH_VIDEO =
  "https://player.vimeo.com/video/1029385613?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const PROSPECT_DETAILS_VIDEO =
  "https://player.vimeo.com/video/1029335844?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const HELP_CENTER_VIDEO =
  "https://player.vimeo.com/video/1027440107?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const CRIE_VIDEO =
  "https://player.vimeo.com/video/1029385419?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const UNIVERSAL_SEARCH_VIDEO =
  "https://player.vimeo.com/video/1027415496?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
export const LEADS_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const PROSPECTS_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const PROSPECTS_DETAIL_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const ORGANIZATION_DETAIL_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const FAVORITE_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const TRAINING_CONFIDENCE_SCORE =
  "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479";
export const ORGANIZATION_DETAIL_TILE_VIEW =
  "https://vimeo.com/1056930103/2d217fc92";
export const LEGISLATIVE_MAP_VIDEO =
  "https://player.vimeo.com/video/1076507208?badge=0&autopause=0&player_id=0&app_id=58479";
export const DEEP_SEARCH_VIDEO =
  "https://player.vimeo.com/video/1076523132?badge=0&autopause=0&player_id=0&app_id=58479";
export const REQUEST_UPDATE =
  "https://player.vimeo.com/video/1076751806?badge=0&autopause=0&player_id=0&app_id=58479";
export const BRE_VIDEO =
  "https://player.vimeo.com/video/1079881270?badge=0&autopause=0&player_id=0&app_id=58479";
export const COMPETITIVE_REPORT =
  "https://player.vimeo.com/video/1078410970?h=e8883bd795&badge=0&autopause=0&player_id=0&app_id=58479";

export const VIDEO_LINKS = {
  COMPETITIVE_INTEL_VIDEO:
    "https://player.vimeo.com/video/1029364639?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  PERSONALIZED_DASHBOARD_VIDEO:
    "https://player.vimeo.com/video/1029387379?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  ARCHIVE_VIDEO:
    "https://player.vimeo.com/video/1027029378?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  AI_PROFILE_VIDEO:
    "https://player.vimeo.com/video/1029332944?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  FAVORITES_VIDEO:
    "https://player.vimeo.com/video/1027017531?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  PUSH_TO_JOSF_VIDEO:
    "https://player.vimeo.com/video/1029398107?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  AI_PATH_VIDEO:
    "https://player.vimeo.com/video/1029369634?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  DATA_ENRICH_VIDEO:
    "https://player.vimeo.com/video/1029385613?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  PROSPECT_DETAILS_VIDEO:
    "https://player.vimeo.com/video/1029335844?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  HELP_CENTER_VIDEO:
    "https://player.vimeo.com/video/1027440107?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  CRIE_VIDEO:
    "https://player.vimeo.com/video/1029385419?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  UNIVERSAL_SEARCH_VIDEO:
    "https://player.vimeo.com/video/1027415496?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  LEADS_CONFIDENCE_SCORE:
    "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479",
  PROSPECTS_CONFIDENCE_SCORE:
    "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479",
  PROSPECTS_DETAIL_CONFIDENCE_SCORE:
    "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479",
  ORGANIZATION_DETAIL_CONFIDENCE_SCORE:
    "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479",
  TRAINING_CONFIDENCE_SCORE:
    "https://player.vimeo.com/video/1056930103?badge=0&autopause=0&player_id=0&app_id=58479",
  ORGANIZATION_DETAIL_TILE_VIEW: "https://vimeo.com/1056930103/2d217fc92",
  LEGISLATIVE_MAP_VIDEO:
    "https://player.vimeo.com/video/1076507208?badge=0&autopause=0&player_id=0&app_id=58479",
  DEEP_SEARCH_VIDEO:
    "https://player.vimeo.com/video/1076523132?badge=0&autopause=0&player_id=0&app_id=58479",
  REQUEST_UPDATE:
    "https://player.vimeo.com/video/1076751806?badge=0&autopause=0&player_id=0&app_id=58479",
  BRE_VIDEO:
    "https://player.vimeo.com/video/1079881270?badge=0&autopause=0&player_id=0&app_id=58479",
  COMPETITIVE_REPORT:
    "https://player.vimeo.com/video/1078410970?h=e8883bd795&badge=0&autopause=0&player_id=0&app_id=58479",
};

// Atlas Training Videos
export const ATLAS_VIDEO_LINKS = {
  ATLAS_CHATTING_BASICS_VIDEO:
    "https://player.vimeo.com/video/1189057384?h=0a4dad142c&badge=0&autopause=0&player_id=0&app_id=58479",
  ATLAS_DEEP_INSIGHTS_VIDEO:
    "https://player.vimeo.com/video/1189064865?h=1c47082eaa&badge=0&autopause=0&player_id=0&app_id=58479",
  ATLAS_PROVIDING_FEEDBACK_VIDEO:
    "https://player.vimeo.com/video/1189053883?h=55f0cd657e&badge=0&autopause=0&player_id=0&app_id=58479",
};
// Atlas Training Job Aids
export const ATLAS_CHATTING_BASICS_JOB_AID =
  "https://app.box.com/shared/static/sagqaiox8qseyj355y9xpv3lao793psj.pdf";
export const ATLAS_DEEP_INSIGHTS_JOB_AID =
  "https://app.box.com/shared/static/lxr9h9wcnlh2x77urx9m5d04h5cjn9jl.pdf";
export const ATLAS_FEEDBACK_JOB_AID =
  "https://app.box.com/shared/static/ib6iedccs0cujc9dl45bhwixaf2fquuj.pdf";

// jobAidLink
export const AI_PATH_JOB_AID =
  "https://app.box.com/shared/static/3wgkdx52ic4b8ah8m7o2ej5ggv9nuz61.pdf";
export const AI_PROFILE_JOB_AID =
  "https://app.box.com/shared/static/5139nu2kpapsuewmabyn7m9c7d3mp5oa.pdf";
export const ARCHIVING_JOB_AID =
  "https://app.box.com/shared/static/ffd32l5b8gyncmtyrnxkixwywn5k9trc.pdf";
export const COMPETITIVE_INTEL_JOB_AID =
  "https://app.box.com/shared/static/plmdfewkm6o4gb647tgu0lectv4138vg.pdf";
export const CRIE_JOB_AID =
  "https://app.box.com/shared/static/r7s4ydmyb1wcvh6g5pak669sy585thru.pdf";
export const DATA_ENRICH_JOB_AID =
  "https://app.box.com/shared/static/9wng7dzzljh0c0unublyr5xxtqu6gke2.pdf";
export const FAVORITES_JOB_AID =
  "https://app.box.com/shared/static/e6x6yct9h91g8umg44k4wbqxvfbuxlq5.pdf";
export const HELP_CENTER_JOB_AID =
  "https://app.box.com/shared/static/0ahbq6step6pg7t2rohp965u2ydzog24.pdf";
export const PERSONALIZES_DASHBOARD_JOB_AID =
  "https://app.box.com/shared/static/duajyy0ydjwnpslh5f5l6ic3jdluvynp.pdf";
export const PROSPECT_DETAILS_JOB_AID =
  "https://app.box.com/shared/static/5c6jnywe0adlrll5o1lsq9k2wk6gwsgg.pdf";
export const PUSH_TO_SALESFORCE_JOB_AID =
  "https://app.box.com/shared/static/uofj9sh2wvq6dn110moycy9l66qcqyew.pdf";
export const UNIVERSAL_SEARCH_JOB_AID =
  "https://app.box.com/shared/static/64bs13ty0z5hqd11lwrsyiv9uxt41x4g.pdf";
export const CONFIDENCE_SCORE_JOB_AID =
  "https://app.box.com/shared/static/p95d3gserfb8iqydda3tlzkjd8e0gidf.pdf";
// export const LEGISLATIVE_MAP_AID = "https://trello.com/1/cards/67b10fd6e080aa5cb28ed1b5/attachments/68015c40f0ea5a23f6ff19ce/download/Job_Aid_Legislative_Map.pdf"
export const LEGISLATIVE_MAP_AID =
  "https://app.box.com/shared/static/l85salc6zu9ro0lsh4mut5qfok7zwrmu.pdf";
// export const DEEP_SEARCH_AID = "https://trello.com/1/cards/67b10fd6e080aa5cb28ed1b5/attachments/68027534e9bfdaa593649489/download/Job_Aid_Deep_Search.pdf"
export const DEEP_SEARCH_AID =
  "https://app.box.com/shared/static/nh48s53rl4fewg6x7t13o2awjmrvyegj.pdf";
// export const REQUEST_UPDATE_AID = "https://trello.com/1/cards/680804eb0094499deb80d84d/attachments/680920318c2ce538e23d4c20/download/JOI_Training-_Request_an_Update.pdf"
export const REQUEST_UPDATE_AID =
  "https://app.box.com/shared/static/wromk5a01fl6mk76yvyqlt0ox7a0yf66.pdf";
export const BRE_AID =
  "https://app.box.com/shared/static/utai5l81erits0sw4to750d6t6po86sd.pdf";
export const COMPETITIVE_REPORT_AID =
  "https://trello.com/1/cards/68124dcc922e518ac4fd48b0/attachments/681d6b67d073a6d3919df23c/download/JOI_Training-Competitive_Intel_Reports.pdf";
